import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

const RouteWithSubRoutes = ({ route }) => (
  <Route
    path={route.pattern}
    exact={route.exactly}
    strict={route.strict}
    render={props => (
      <route.component {...props} routes={route.routes} />
    )}
  />
)
RouteWithSubRoutes.propTypes = {
  route: PropTypes.object.isRequired,
}

export default RouteWithSubRoutes



// WEBPACK FOOTER //
// ./src/browser/components/routing/RouteWithSubroutes.js